import { FilterTypes } from '../../store/reducers/productFilter.reducer';
import { ProductTypes } from '../../types/product/product';

export const isProductRebond = (
  rebond: FilterTypes['rebond']
): Predicate<ProductTypes> => product => product.venterebond === rebond;
